import {
  AfterContentInit,
  AfterViewChecked,
  Component,
  ContentChild,
  ContentChildren,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  TemplateRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TableRowDirective } from './directives/table-row.directive';
import { TableTemplate } from './directives/table-template.directive';
import { TableService } from './table.service';

@Component({
  selector: 'f-table',
  templateUrl: 'table-updated.component.html',
})
export class TableComponent implements AfterContentInit, OnInit, OnDestroy {
  @ContentChildren(TableTemplate) templates!: QueryList<TableTemplate>;
  @Input() tableClass: string = 'table-module table-module--minimal';
  @Input() paging = {
    size: 20,
    page: 1,
    total: 0,
  };
  @Input() columns: any[] = [];
  @Input() rows: any[] = [];
  @Input() tTemplate = '';
  noDataTemplate!: TemplateRef<any>;
  bodyTemplate!: TemplateRef<any>;
  bodyDetailTemplate!: TemplateRef<any>;
  headerTemplate!: TemplateRef<any>;
  subscriptions = new Array<Subscription>();
  constructor(public tableService: TableService) {}
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }
  ngOnInit(): void {
    this.subscriptions.push(
      this.tableService.$sort.subscribe((column: any) => {
        this.columns
          .filter((x) => x.key !== column.key)
          .forEach((x: any) => {
            x.order = 0;
          });
      })
    );
  }
  ngAfterContentInit(): void {
    this.templates.forEach((template: TableTemplate) => {
      if (template.name === 'body') {
        this.bodyTemplate = template.template;
      } else if (template.name === 'bodyDetail') {
        this.bodyDetailTemplate = template.template;
      } else if (template.name === 'header') {
        this.headerTemplate = template.template;
      } else if (template.name === 'nodata') {
        this.noDataTemplate = template.template;
      }
    });
  }
}
